import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenAttendancesIndicatorM1Data } from "@/services/esus/indicator/emulti/m1/getDetailedCitizenAttendancesIndicatorM1";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEmultiM1AttendancesHistoryItem } from "./IndicatorEmultiM1AttendancesHistoryItem";
import { IndicatorEmultiM1GroupActivitiesHistoryItem } from "./IndicatorEmultiM1GroupActivitiesHistoryItem";
import { IndicatorEmultiM1CitizenHistoryInfo } from "./IndicatorEmultiM1CitizenHistoryInfo";
import { timeDimensionToString } from "@/utils/dateUtil";

type IndicatorEmultiM1CitizenAttendancesHistoryProps = {
	detailedCitizenAttendancesIndicatorM1: DetailedCitizenAttendancesIndicatorM1Data;
};

export function IndicatorEmultiM1CitizenAttendancesHistory({
	detailedCitizenAttendancesIndicatorM1,
}: Readonly<IndicatorEmultiM1CitizenAttendancesHistoryProps>) {
	const indicatorEmultiC1CitizenHistoryInfo = {
		fullName: detailedCitizenAttendancesIndicatorM1.fullName
			? detailedCitizenAttendancesIndicatorM1.fullName
			: "N/A",
		birthdate: detailedCitizenAttendancesIndicatorM1.birthdate,
		document: detailedCitizenAttendancesIndicatorM1.cpf
			? formatIdentifier(detailedCitizenAttendancesIndicatorM1.cpf)
			: detailedCitizenAttendancesIndicatorM1.cns ?? "",
		motherName: detailedCitizenAttendancesIndicatorM1.motherName ?? "",
		phone: detailedCitizenAttendancesIndicatorM1.phone
			? phoneFormat(detailedCitizenAttendancesIndicatorM1.phone)
			: "",
		address:
			addressConcat(
				detailedCitizenAttendancesIndicatorM1.street,
				detailedCitizenAttendancesIndicatorM1.houseNumber,
				detailedCitizenAttendancesIndicatorM1.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEmultiM1CitizenHistoryInfo {...indicatorEmultiC1CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Atendimentos individuais"
				timeLineContents={(detailedCitizenAttendancesIndicatorM1.attendances ?? [])
					.filter((a) => Boolean(a.timeDimensionId))
					.map<TimeLineContent>((attendance) => {
						return {
							content: (
								<IndicatorEmultiM1AttendancesHistoryItem attendance={attendance} />
							),
							eventDate: attendance.timeDimensionId
								? timeDimensionToString(attendance.timeDimensionId!, "DD/MM/YYYY")
								: "N/A",
						};
					})}
			/>
			<TimeLine
				timeLineTitle="Atividades coletivas"
				timeLineContents={(
					detailedCitizenAttendancesIndicatorM1.groupActivitiesCitizen ?? []
				).map<TimeLineContent>((groupActivityCitizen) => {
					return {
						content: (
							<IndicatorEmultiM1GroupActivitiesHistoryItem
								groupActivityCitizen={groupActivityCitizen}
							/>
						),
						eventDate: groupActivityCitizen.timeDimensionId
							? timeDimensionToString(
									groupActivityCitizen.timeDimensionId!,
									"DD/MM/YYYY"
							  )
							: "N/A",
					};
				})}
			/>
		</>
	);
}
